import { PropTypes } from "aem/ComponentWrapper";
import React from "react";

export default {
  title: "Link",
  type: "rh/components/content/link",
  isContainer: true,
  config: {
    emptyLabel: "Link",
    isEmpty: ({ children }: PropTypes) => React.Children.count(children) === 0
  }
};
